<template>
  <div class="notification-element" :class="[extraCardClasses, 'individual-text-notification-banner']"
       id="individualNotificationBanner">
    <div class="individual-text-notification" :class="{card: addCardClasses}">
      <div class="inner">
        <div class="text">
          <div class="ribbon" v-if="isSlotNotEmpty('txtBeforeIndividualTextNotification')"><slot name="txtBeforeIndividualTextNotification">Text Before</slot></div>
          <slot name="txtIndividualTextNotification">Text Banner</slot>
        </div>
        <div class="button" v-if="textNotifications.button">
          <slot name="btnIndividualTextNotification"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'IndividualNotificationBanner',
  data () {
    return {
      loading: false
    }
  },
  computed: {
    addCardClasses: function () {
      return this.addCardClass
    },
    extraCardClasses: function () {
      if (this.addCardClass) {
        return 'card-wrapper notification-card'
      } else {
        return ''
      }
    }
  },
  props: {
    addCardClass: {
      type: Boolean,
      default: false
    },
    textNotifications: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
